import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/i18n';
import Markdown from '../guides/Markdown';
import assistTerms from './policies/assist-terms.md?raw';
import consultantAgreement from './policies/consultant-agreement.md?raw';

export default function AssistPolicyPage({ policy }: { policy: 'terms' | 'agreement' }) {
  const { lang, t } = useLanguage();
  return (
    <section style={{ maxWidth: 760, margin: '0 auto' }}>
      <div className="card">
        {lang !== 'en' && <p className="field-hint" style={{ marginTop: 0 }}>{t('This page is only available in English for now.')}</p>}
        <div lang="en" dir="ltr">
          <Markdown text={policy === 'terms' ? assistTerms : consultantAgreement} />
        </div>
        <div className="toolbar">
          <Link className="btn secondary" to="/assist">{t('Back')}</Link>
        </div>
      </div>
    </section>
  );
}
